import Vue from "vue";
import Router from "vue-router";
import store from '../store';
import api from "../config/_api";
import {AUTH_LOGOUT,AUTH_REQUEST_TOKEN_FULL} from '../store/actions/auth';
import {isSubscriptionValid} from '../store/modules/auth'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer.vue');

// Dashboard
const Dashboard = () => import("@/views/Dashboard.vue");

// Systems
const SystemsIndex = () => import("@/views/Systems/Index.vue");
const SystemsAdd = () => import("@/views/Systems/Add.vue");
const SystemsEdit = () => import("@/views/Systems/Edit.vue");
const SystemsImport = () => import("@/views/Systems/Import.vue");

// Adherents
const AdherentsIndex = () => import("@/views/Adherents/Index.vue");
const AdherentsAdd = () => import("@/views/Adherents/Add.vue");
const AdherentsEdit = () => import("@/views/Adherents/Edit.vue");
const AdherentsImport = () => import("@/views/Adherents/Import.vue");

const ValiderMonAdressMail = () => import("@/views/Adherents/ValiderMonAdressMail.vue");

//User Group

const UserGroupsIndex = () => import("@/views/UserGroups/Index.vue");
const UserGroupsAdd = () => import("@/views/UserGroups/Add.vue");
const UserGroupsEdit = () => import("@/views/UserGroups/Edit.vue");

// Sensors
const SensorsIndex = () => import("@/views/Sensors/Index.vue");

//Plaques
const PlatesIndex = () => import("@/views/Plates/Index.vue");

// Calendar
const CalendarSelect = () => import("@/views/Calendars/CalendarSelectView.vue");
const CalendarView = () => import("@/views/Calendars/CalendarView.vue");

// Login
const Login = () => import("@/views/Login.vue");

// Extraction
const Extraction = () => import("@/views/Extraction.vue");

const Profile = () => import("@/views/Profile.vue");

const ResetPasswordForm = () => import("@/views/ResetPassword/ResetPasswordForm.vue");

const MesInvitations = () => import("@/views/Role");

const  toAdherent = () => import("@/views/redirect"); 

Vue.use(Router);


const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    } else {
        next('/');
    }
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        setTimeout(() => { store.dispatch('adherents/getRoleInvitations'); }, 1000); 
        
        return;
    } else {
        next({
            path: '/login',
            query: { redirect: '' }
        });
    }
    
};

const transmitDataToAdherent =  (to, from, next) => {
    if (store.getters.isAuthenticated) {

        setTimeout(() => {
            next();
        }, 4000); 
        
        return;
    }
    next();
};

const tryAutoConnect = (to, from, next) => {
    store.dispatch(AUTH_REQUEST_TOKEN_FULL, {api_token: to.params.token, email: to.params.email, struct_id:to.params.struct_id, role:to.params.role}).then(() => {
        if(ifAuthenticated){
            if(to.params.role == 3){
                next({path : '/redirect/Adherent/'+to.params.token+'/'+to.params.email+'/'+to.params.struct_id+'/'+to.params.role, component: toAdherent , params : to.params});
            }
            else{
                if(to.query!=null && to.query.redirect!=null && to.query.redirect=="agenda" && to.query.id!=null){
                    next({path: "/m.calendar/"+to.query.id , beforeEnter: checkSubscription, component: CalendarView});
                }
                else{
                    next({path: "/dashboard", props: {showSubscriptionPopup : !isSubscriptionValid()}});
                }
            }
        }
        else{
            next('/login');
        }
        
    })/*.catch(err => {
        console.log(err);
        next('/login');
    })*/;
    
};

const checkSubscription = (to, from, next) => {
    if (isSubscriptionValid()){
        next();
    }
    else{
        next({
            path: '/',
            query: { redirect: to.fullPath }
        });
    }
    return;
};

const logout = (to, from, next) => {
    store.dispatch(AUTH_LOGOUT,1)
        .then(() => {
            next('/login');
        });
};

const notFound  = (to, from, next)=>{
    next('/dashboard');
};

export default new Router({
    linkActiveClass: 'open active',
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            name: "Home",
            beforeEnter: ifAuthenticated,
            component: DefaultContainer,
            children: [                
                { path: "/dashboard", name: "dashboard", component: Dashboard ,props: {showSubscriptionPopup : !isSubscriptionValid()}},
                { path: "/systems/index", beforeEnter: checkSubscription, component: SystemsIndex },
                { path: "/systems/add", beforeEnter: checkSubscription, component: SystemsAdd },
                { path: "/systems/edit", beforeEnter: checkSubscription, component: SystemsEdit },
                { path: "/systems/import", beforeEnter: checkSubscription, component: SystemsImport },
                { path: "/adherents/index", beforeEnter: checkSubscription, component: AdherentsIndex },
                { path: "/adherents/add", beforeEnter: checkSubscription, component: AdherentsAdd },
                { path: "/adherents/edit", beforeEnter: checkSubscription, component: AdherentsEdit },
                { path: "/adherents/import", beforeEnter: checkSubscription, component: AdherentsImport },
                { path: "/usergroup/index", beforeEnter: checkSubscription, component: UserGroupsIndex },
                { path: "/usergroup/add", beforeEnter: checkSubscription, component: UserGroupsAdd },
                { path: "/usergroup/edit", beforeEnter: checkSubscription, component: UserGroupsEdit },
                { path: "/sensors/index", component: SensorsIndex ,props: {subscriptionOK : isSubscriptionValid()}},
                { path: "/plates/index", component: PlatesIndex },
                { path: "/calendar", beforeEnter: checkSubscription, component: CalendarSelect },
                { path: "/calendar/:id", beforeEnter: checkSubscription, component: CalendarView },
                { path: "/logout", beforeEnter: logout},
                { path: "/profile", beforeEnter: checkSubscription, component: Profile},
                { path: "/extraction", /*beforeEnter: checkSubscription,*/ component: Extraction, props: {subscriptionOK : isSubscriptionValid()}},
                {path : '/Mes-Invitations/:token', component: MesInvitations} ,
                {path : '/Mes-Invitations/', component: MesInvitations},
                
            ]
        }, 
        //Page de login normale
        { path: '/login', component: Login, beforeEnter: ifNotAuthenticated },
        //Page de login sans saisie d'identifiant mdp
        { path: '/login/:token/:email', component: Login, beforeEnter: ifNotAuthenticated},
        //Path qui va complétement skipper la phase de login et du choix du rôle
        { path: '/login/:token/:email/:struct_id/:role', component: DefaultContainer, beforeEnter: tryAutoConnect},
        { path : '/resetpassword/:token',component: ResetPasswordForm },
        { path : '/resetpassword',  component: ResetPasswordForm },
        { path : '/Premiere-Connexion/:token',  component: ResetPasswordForm },
        { path : '/Premiere-Connexion', component: ResetPasswordForm },
        { path : '/redirect/Adherent', component: toAdherent , beforeEnter:transmitDataToAdherent},
        {path : '/redirect/Adherent/:token/:email/:struct_id/:role', component: toAdherent, beforeEnter:transmitDataToAdherent},
        { path : '/ValiderMonAdressMail/:token', component :ValiderMonAdressMail },

        { path: "/m.calendar/:id", beforeEnter: checkSubscription, component: CalendarView },

        { path: '*',beforeEnter :notFound}
    ]
});
